<template>
  <div class="drawer" :class="{open: isOpen}">
    <div class="controls">
      <button @click="$emit('close')">
        <i class="material-icons open-item" v-if="!isOpen">menu</i>
        <i class="material-icons" v-if="isOpen">close</i>
        <!-- <i class="material-icons" v-else>keyboard_arrow_right</i> -->
      </button>
    </div>

    <div class="user">
      <div><i class="material-icons">account_circle</i> User #1523</div>
    </div>
    <figure></figure>
    
    <div id="nav" @click="$emit('close')">
      <transition-group tag="ul" name="fade" v-if="isOpen">
        <li key="1"><router-link to="/">Home</router-link><i class="material-icons">arrow_forward</i></li>
        <li key="2"><hr></li>
        <li key="3"><router-link to="/trainee/scenario/10/playlist/w1">Match operations (UEFA MOC)</router-link><i class="material-icons">arrow_forward</i></li>
        <li key="4"><router-link to="/trainee/scenario/12/playlist/a1">Approach to stadium (UEFA EURO Tournaments)</router-link><i class="material-icons">arrow_forward</i></li>
        <li key="5"><router-link to="/trainee/scenario/13/playlist/p1">Pyrotechnics training on the job (Clubs)</router-link><i class="material-icons">arrow_forward</i></li>
        <li key="6"><router-link to="/trainee/scenario/3/playlist/pl1">Plenary scenario (UEFA stadium & security events)</router-link><i class="material-icons">arrow_forward</i></li>
        <li key="7"><hr></li>
        <li key="8"><router-link to="/code">Access code</router-link><i class="material-icons">arrow_forward</i></li>
        <li key="9"><router-link to="/reader">Reader</router-link><i class="material-icons">arrow_forward</i></li>
        <li key="10"><router-link to="/quick-event">Quick Event</router-link><i class="material-icons">arrow_forward</i></li>
      </transition-group>
    </div>
    <div class="copy">
      <p>Copyright 2020<br>
      UEFA Safety and Security</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Drawer",
  props: {
    openDrawer: {
      type: String,
    },
  },
  data () {
    return {
      // isOpen: false
    }
  },
  computed: {
    isOpen () {
      return (this.openDrawer === "menu" ? true : false)
    }
  },
};
</script>

<style lang="scss" scoped>

  .drawer {
    display: grid;
    grid-template-areas: 
      ". user profile . controls"
      ". .... ...... . ........"
      ". navi navi navi navi"
      ". copy copy copy ........";
    grid-template-columns: 25px 110px 55px 110px 50px;
    grid-template-rows: 40px 62px 1fr auto;
    position: absolute;  
    z-index: 400;
    top: 0;
    left: 0;
    width: 350px;
    height: 160px;
    
    padding: 22px 0 25px;
    // background-color: darken(#3d3dde, 20%);
    color: #fff;

    transform: translateX(-100%);
    transition: all 0.25s cubic-bezier(0.4, 0.0, 0.2, 1);

    &.open {
      position: fixed;
      height: 100vh;
      transform: translateX(0);
      transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
      background-color: darken(#3d3dde, 20%);
    }

    @media all and (min-width: 768px) {
      // background-color: darken(#3d3dde, 20%);
      // position: fixed;
      height: 100vh;
    }
  }
  .controls {
    grid-area: controls;
    // text-align: center;
    justify-content: flex-start;
    display: flex;

    button {
      background: none;
      border: none;
      color: #fff;
      width: 20px;
      padding: 0;
    }
    .open-item {
      margin-left: 10px;
    }
  }

  .user {
    grid-area: user;
    display: flex;
    align-items: center;

    div {
      display: flex;
      align-items: center;
      font-size: 15px;

      i {
        margin-right: 10px;
      }
    }
  }
  figure {
    grid-area: profile;
    border-radius: 50%;
    background-color: #fff;
    width: 55px;
    height: 55px;
    margin: 0 auto;
  }

  #nav {
    grid-area: navi;
    line-height: 2em;
    font-size: 22px;
    font-size: 19px;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        align-items: center;
        // padding-right: 25px;
        padding: 0.5em 25px 0.5em 0;

        a {
          margin-right: auto;
        }
      }
    }

    a {
      font-weight: bold;
      color: #8D8DD0;
      display: block;
      text-decoration: none;
      text-align: left;
      line-height: 1.2em;
      padding-right: 20px;

      &:hover,
      &.router-link-exact-active {
        color: #fff;

        & + i {
          color: #fff;
        }
      }
    }
    i {
      color: #8D8DD0;
    }
  }

  hr {
    height: 0;
    border: 0;
    border-top: 2px solid #7474CA;
    flex: 1;
  }

  .copy {
    grid-area: copy;
  }
</style>